/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Blog 

 
 $( document ).ready(function () {

    var div_found = 0;
    var myInterval = setInterval(function () {
            if(div_found){
              	clearInterval(myInterval);
            }else{
              if($("#insta-feed").length > 0){
                console.log('Found');
                div_found = 1;
                setTimeout(function(){ 
                  	$('#insta-feed').prepend('<div class="insta-slider"></div>');
                    $('#insta-feed > a').each(function () {
                        if(!$(this).hasClass('instafeed-lightbox')){
                            $('.insta-slider').append($(this));
                        }
                    });
                    
                    $('.insta-slider').slick({
                        infinite: true,
                        speed: 300,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        prevArrow: "<button class='slick-prev-next-button previous' type='button' aria-label='previous'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow'></path></svg>P</button>",
                        nextArrow: "<button class='slick-prev-next-button next' type='button' aria-label='next'><svg viewBox='0 0 100 100'><path d='M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg>P</button>",

                        responsive: [
                          {
                            breakpoint:1199,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll:3,
                            }
                          },
                          {
                            breakpoint:991,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll:2,
                            }
                          },
                          {
                            breakpoint: 567,
                            settings: {
                              centerMode: true,
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]

                    });
                  $('.insta-slider .slick-slide img').each(function() {
                      if( $(this).attr('src').indexOf('pixel.gif') > -1 ){
                          $(this).attr('src',$(this).attr('data-src'));
                      }
                  });
                }, 1500);
              }else{
               
              }
            }
      
        },1000);

    //   end accessibility icon move
   
   $(document).on('click','#insta-feed .instafeed-lightbox:first .arrows object:first',function(){setTimeout(function(){$('body').css('overflow','');}, 500);});
   $(document).on('click','#insta-feed .instafeed-lightbox:last-child .arrows object:last-child',function(){setTimeout(function(){$('body').css('overflow','');}, 500);});
    
  });
Shopify.cartRelated = function(){
  $.ajax({url: "https://www.alexandragioia.com/cart?view=related-item", success: function(result){$('#cartDrawer #relatedProducts').html($(result).find('#relatedProducts').html()) }  });
}